import { render } from "./VillaLogs.vue?vue&type=template&id=466592c4"
import script from "./VillaLogs.vue?vue&type=script&lang=js"
export * from "./VillaLogs.vue?vue&type=script&lang=js"
script.render = render

export default script